import { FC, SVGProps } from 'react';

const LoadingV2: FC<SVGProps<SVGSVGElement>> = (
  props: SVGProps<SVGSVGElement>
) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17 7C17 7.5625 16.5 8 16 8C15.4375 8 15 7.5625 15 7V1C15 0.5 15.4375 0 16 0C16.5 0 17 0.5 17 1V7ZM17 31C17 31.5625 16.5 32 16 32C15.4375 32 15 31.5625 15 31V25C15 24.5 15.4375 24 16 24C16.5 24 17 24.5 17 25V31ZM0 16C0 15.5 0.4375 15 1 15H7C7.5 15 8 15.5 8 16C8 16.5625 7.5 17 7 17H1C0.4375 17 0 16.5625 0 16ZM31 15C31.5 15 32 15.5 32 16C32 16.5625 31.5 17 31 17H25C24.4375 17 24 16.5625 24 16C24 15.5 24.4375 15 25 15H31ZM27.3125 4.6875C27.6875 5.125 27.6875 5.75 27.3125 6.125L23.0625 10.375C22.625 10.75 22 10.75 21.625 10.375C21.25 10 21.25 9.375 21.625 8.9375L25.875 4.6875C26.25 4.3125 26.875 4.3125 27.3125 4.6875ZM6.0625 27.3125C5.6875 27.75 5.0625 27.75 4.625 27.3125C4.25 26.9375 4.25 26.3125 4.625 25.9375L8.875 21.6875C9.3125 21.3125 9.9375 21.3125 10.3125 21.6875C10.6875 22.0625 10.6875 22.6875 10.3125 23.125L6.0625 27.3125ZM4.625 4.6875C5.0625 4.3125 5.6875 4.3125 6.0625 4.6875L10.3125 8.9375C10.6875 9.375 10.6875 10 10.3125 10.375C9.9375 10.75 9.3125 10.75 8.875 10.375L4.625 6.125C4.25 5.75 4.25 5.125 4.625 4.6875ZM27.3125 25.9375C27.6875 26.3125 27.6875 26.9375 27.3125 27.3125C26.875 27.75 26.25 27.75 25.875 27.3125L21.625 23.125C21.25 22.6875 21.25 22.0625 21.625 21.6875C22 21.3125 22.625 21.3125 23.0625 21.6875L27.3125 25.9375Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default LoadingV2;
